<div [ngClass]="showTopBand && !inDrawer ? 'cipx-viewer-pane' : ''">
  <div class="cipx-viewer-pane-header justify-start p-4 bg-brandDarkBlue" *ngIf="showTopBand">
    <div *ngIf="isScreenSmall">
      <button class="ml-0 md:ml-4" mat-icon-button [matTooltip]="'Back to Open Items'" (click)="closePanel()">
        <mat-icon color="primary" [svgIcon]="'heroicons_outline:arrow-narrow-left'"></mat-icon>
      </button>
    </div>
    <span class="flex justify-start gap-4 items-center text-white font-bold">New Message</span>
  </div>

  <div [ngClass]="showTopBand && !inDrawer ? 'cipx-viewer-pane-body' : ''">
    @if (!inDrawer) {
      <div [ngClass]="{ 'w-full p-2': fullWidth || isScreenSmall, 'w-9/12 p-4': !fullWidth }">
        <mat-card class="shadow-lg">
          <mat-card-content>
            <ng-container [ngTemplateOutlet]="formContent"></ng-container>
          </mat-card-content>
        </mat-card>
      </div>
    } @else {
      <div class="cipx-form-container w-full">
        <cipx-scrollable-content [noPadding]="false">
          <div class="rounded-lg">
            <div class="w-full flex flex-col justify-between pt-0 mb-[100px]">
              <ng-container [ngTemplateOutlet]="formContent"></ng-container>
            </div>
          </div>
        </cipx-scrollable-content>
      </div>
    }
  </div>
</div>

<ng-template #formContent>
  <form [formGroup]="_formGroup" class="flex flex-col gap-1">
    <!-- Recipient Input -->
    <mat-form-field appearance="fill" hideRequiredMarker="true" class="w-full mt-1">
      <mat-label>Subject</mat-label>
      <input matInput type="text" placeholder="Subject" formControlName="task_label" class="w-full" />
    </mat-form-field>

    @if (!isReplying) {
      <div class="mb-4" *ngIf="_suretyTeamService.recipientList()?.length > 1">
        <mat-label>Recipient</mat-label>
        <div class="gap-1" [ngClass]="{ 'grid grid-cols-3 ': !isScreenSmall, 'grid grid-cols-1': isScreenSmall }">
          <mat-checkbox
            [disabled]="isSubmitting"
            *ngFor="let member of _suretyTeamService.recipientList()"
            [value]="member.id?.toString()"
            [color]="'primary'"
            [checked]="markAsChecked(member)"
            (change)="onTeamSelectChange($event, member)">
            @if (member.name) {
              @if (member.scope_key === 'xbadminscope') {
                {{ getSuretyTeamMemberById(+member.id) }}
              }
              {{ member.name }}
            }
          </mat-checkbox>
        </div>
        <mat-error *ngIf="!selectedRecipients?.length && shouldShowError('assign_to')">
          Please select a receiver.
        </mat-error>
      </div>
    } @else {
      <div class="mb-4" *ngIf="recipientList?.length > 1">
        <mat-label>Recipient</mat-label>
        <div class="gap-1" [ngClass]="{ 'grid grid-cols-3 ': !isScreenSmall, 'grid grid-cols-1': isScreenSmall }">
          @for (member of recipientList; track member.id; let i = $index) {
            <mat-checkbox
              *ngIf="
                !['cipxaccountuser', 'cipxaccount'].includes(member.scope_key) &&
                +member.id !== +_userService.currentAccountUser().id
              "
              [disabled]="true"
              [color]="'primary'"
              checked="true">
              @if (member.name) {
                @if (member.scope_key === 'xbadminscope') {
                  <!--{{ member | json}}-->
                  {{ getSuretyTeamMemberById(+member.id) }}
                }

                {{ member.name }}
              }
            </mat-checkbox>
          }
        </div>
      </div>
    }

    <!-- Permission Description -->
    <div class="mb-2 pb-2">
      <mat-label>Message</mat-label>
      <tiny-editor
        [editorOptions]="{ min_height: inDrawer ? 500 : 200, max_height: 800, resize: true }"
        controlName="task_description"
        [spellcheck]="true"
        editorType="basic"></tiny-editor>
      <mat-error *ngIf="shouldShowError('task_description')">
        Message is required.
      </mat-error>
    </div>

    <!-- Uploader -->
    <div class="mb-2 pb-2">
      <button mat-raised-button class="flex items-center mt-4" [disabled]="isSubmitting" (click)="openFileUploader()">
        <mat-icon>upload</mat-icon>
        <span class="ml-2 mr-1">Attach Files</span>
      </button>
    </div>

    <div class="mb-2 pb-2" *ngIf="queuedFiles?.length > 0">
      <span class="my-2 font-semibold">Selected files</span>
      <div class="flex flex-col gap-2 justify-start w-full overflow-x-auto">
        <div *ngFor="let file of queuedFiles; let i = index">
          <div class="flex flex-row items-center">
            <button mat-icon-button color="warn" (click)="deleteFile(i)">
              <mat-icon>delete</mat-icon>
            </button>
            <div class="flex flex-col hover:bg-slate-50 hover:dark:bg-slate-700">
              <p class="truncate text-xs uppercase text-gray-500">Documentation</p>
              <p class="truncate max-w-[150px] md:max-w-[600px]">
                {{ file.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Send/Cancel Inline Buttons (optional) -->
    <div class="flex flex-row gap-2 items-center justify-start mt-4" *ngIf="showInlineButtons">
      <button
        class="flex items-center mt-4 text-white hover:text-gray-200 w-[150px]"
        mat-raised-button
        [color]="'primary'"
        [disabled]="isSubmitting"
        (click)="sendMessageAction()">
        <mat-icon>send</mat-icon>
        <span class="ml-2 mr-1">Send</span>
      </button>
      <button
        mat-raised-button
        [disabled]="isSubmitting"
        class="flex items-center mt-4 w-[150px]"
        (click)="closePanel()">
        <span class="ml-2 mr-1">Cancel</span>
      </button>
    </div>
  </form>
</ng-template>
